// Block-2-Karte „Risiken" (AP-Ri, DD5/DD7/DD8): KPI „N Risiken" (Gesamt) plus
// die Status-Aufschlüsselung „in Bearbeitung"/„Entwurf" (DD7) als kompakte
// Status-Chips sowie ein Link zur Risiken-Liste (`/risks`).
//
// Datenquelle: `dashboardService.getRiskCountByStatus()` →
// `GET /risk-objects/count/by-status` (mandanten-scoped, #457). Der Endpunkt
// zählt tenantweit (keine Owner/Team-Aufschlüsselung im Aggregat), daher zeigt
// die Karte die tenantweiten Zahlen; eine Meine/Team-Aufschlüsselung wäre ein
// Folge-Detail (siehe PR-Body) und wird hier bewusst NICHT als (wirkungslose)
// Pill vorgegaukelt.
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Warning20Regular, ChevronRight16Regular } from "@fluentui/react-icons";
import { dashboardService } from "../../services/dashboardService";
import { REFINED } from "../risikoanalyseStep/tokens";
import { DashCard, EmptyHint } from "./DashboardShared";

export const RisikenCard: React.FC = () => {
    const navigate = useNavigate();
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        dashboardService
            .getRiskCountByStatus()
            .then((res) => {
                if (cancelled) return;
                setTotal(res.total);
            })
            .catch(() => {
                if (cancelled) return;
                setTotal(0);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    const goAll = () => navigate("/risks");

    return (
        <DashCard
            title="Risiken"
            icon={<Warning20Regular />}
            right={
                <button
                    type="button"
                    onClick={goAll}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        color: REFINED.aub,
                        fontFamily: REFINED.fontUI,
                        fontSize: "0.88rem",
                        fontWeight: 700,
                        padding: 0,
                    }}
                >
                    Alle anzeigen <ChevronRight16Regular />
                </button>
            }
        >
            {loading ? (
                <EmptyHint>Lade Risiken…</EmptyHint>
            ) : (
                <>
                    {/* KPI: N Risiken (Gesamt) */}
                    <div style={{ display: "flex", alignItems: "baseline", gap: 8, padding: "8px 6px 12px" }}>
                        <span
                            style={{
                                fontSize: "2rem",
                                fontWeight: 800,
                                color: REFINED.ink,
                                lineHeight: 1,
                                fontVariantNumeric: "tabular-nums",
                            }}
                        >
                            {total}
                        </span>
                        <span style={{ fontSize: "0.92rem", color: REFINED.ink2, fontWeight: 600 }}>
                            {total === 1 ? "Risiko" : "Risiken"}
                        </span>
                    </div>

                    {/* Bei 0 Risiken weiterhin ein klarer Leerhinweis (P7: Status-Chips „In Bearbeitung"/„Entwurf" entfernt). */}
                    {total === 0 && <EmptyHint>Keine Risiken erfasst.</EmptyHint>}
                </>
            )}
        </DashCard>
    );
};

export default RisikenCard;
